(function(){
  'use strict';
  
  const initMobilePromo = () => {
    const slot = document.querySelector('.promo-mobile-slot');
    const desktop = document.querySelector('.product__promo--desktop');
    
    if(!slot || !desktop) return;
    
    const mobile = desktop.cloneNode(true);
    mobile.classList.replace('product__promo--desktop', 'product__promo--mobile');
    slot.appendChild(mobile);
  };
  
  const initCopyHandlers = () => {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.promo__copy');
      if(!btn) return;
      
      const code = btn.dataset.code;
      if(!code) return;
      
      navigator.clipboard.writeText(code).then(() => {
        const original = btn.textContent;
        btn.textContent = '✓ Kopiert!';
        btn.classList.add('copied');
        
        setTimeout(() => {
          btn.textContent = original;
          btn.classList.remove('copied');
        }, 2000);
      });
    }, {passive: true});
  };
  
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', () => {
      initMobilePromo();
      initCopyHandlers();
    });
  } else {
    initMobilePromo();
    initCopyHandlers();
  }
})();